module.exports = __webpack_public_path__ + "static/media/illustrator.6deb63cd.svg";